<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
            <div class="nav">
              <ul>
                <li @click="goPage('Home')">首页</li>
                <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                <li @click="goPage('MyCar')">我的购物车</li>
                <li @click="goPage('MyOrder')">我的订单</li>
                <li @click="goPage('Calculator', true)">计算器</li>
                <li @click="goPage('FeedBack', true)">问题反馈</li>
                <li @click="goPage('ChangePass')">修改密码</li>
                <li @click="loginOut">注销登录</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container-diam">
        <div class="title-box webCSS">
          <span class="title_1">GIA裸钻查询</span>
        </div>
        <div class="reveal-modal" style="height: auto">
          <a class="close-reveal-modal mobileCSS" id="btn_reveal">&#215;</a>
          <div class="con-search" name="whitedia">
            <div id="searchform">
              <div class="con-shape">
                <dl class="para-shape">
                  <dt>形状</dt>
                  <div class="DiamondSearch-item-container clearfix">
                    <div class="DiamondSearch-item-shape" v-for="(item, index) in shapeList" :key="index">
                      <div class="DiamondSearch-item-shape-box" :class="item.selected && 'active'" @click="selectItem(item, 'shape')">
                        <div class="DiamondSearch-item-shape-icon" :class="item.name"></div>
                        <div class="DiamondSearch-item-shape-text">{{item.text}}</div>
                      </div>
                    </div>
                  </div>
                </dl>
                <dl class="para-dl-select">
                  <dt>
                    颜色
                    <span></span>
                  </dt>
                  <div class="DiamondSearch-item-container normal clearfix">
                    <div class="DiamondSearch-item-normal" v-for="(item, index) in colorList" :key="index">
                      <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'color')">{{item.name}}</button>
                    </div>
                  </div>
                </dl>
                <dl class="para-dl-select">
                  <dt>净度</dt>
                  <div class="DiamondSearch-item-container normal clearfix">
                    <div class="DiamondSearch-item-normal" v-for="(item, index) in clarityList" :key="index">
                      <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'clarity')">{{item.name}}</button>
                    </div>
                  </div>
                </dl>
                <div class="para-div-lt">
                  <dl class="para-dl-select">
                    <dt>
                      三项
                      <span></span>
                    </dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.three == '3IDEAL' && 'active'" @click="selectThree('3IDEAL')">3IDEAL</button>
                      </div>
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.three == '3EX' && 'active'" @click="selectThree('3EX')">3EX</button>
                      </div>
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.three == '3VG' && 'active'" @click="selectThree('3VG')">3VG</button>
                      </div>
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.three == '3GD' && 'active'" @click="selectThree('3GD')">3GD</button>
                      </div>
                    </div>
                  </dl>
                  <dl class="para-dl-select">
                    <dt>
                      切工
                      <span></span>
                    </dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info" v-for="(item, index) in cutList" :key="index">
                        <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'cut')">{{item.name}}</button>
                      </div>
                    </div>
                  </dl>
                  <dl class="para-dl-select">
                    <dt>
                      抛光
                      <span></span>
                    </dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info" v-for="(item, index) in polishList" :key="index">
                        <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'polish')">{{item.name}}</button>
                      </div>
                    </div>
                  </dl>
                  <dl class="para-dl-select">
                    <dt>对称</dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info" v-for="(item, index) in symList" :key="index">
                        <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'sym')">{{item.name}}</button>
                      </div>
                    </div>
                  </dl>
                  <dl class="para-dl-select">
                    <dt>荧光</dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info flour" v-for="(item, index) in flourList" :key="index">
                        <button class="DiamondSearch-item-normal-info" :class="item.selected && 'active'" @click="selectItem(item, 'flour')">{{item.name}}</button>
                      </div>
                    </div>
                  </dl>
                </div>
                <div class="para-div-lt">
                  <dl class="para-dl-select">
                    <dt>奶色</dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.Milky == 1 && 'active'" @click="selectItemOne(1, 'Milky')">有奶</button>
                      </div>
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.Milky == '0' && 'active'" @click="selectItemOne('0', 'Milky')">无奶</button>
                      </div>
                    </div>
                  </dl>
                  <dl class="para-dl-select">
                    <dt>咖色</dt>
                    <div class="DiamondSearch-cut-list clearfix">
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.Browness == 1 && 'active'" @click="selectItemOne(1, 'Browness')">有咖</button>
                      </div>
                      <div class="DiamondSearch-cut-list-info">
                        <button class="DiamondSearch-item-normal-info" :class="database.search.Browness == '0' && 'active'" @click="selectItemOne('0', 'Browness')">无咖</button>
                      </div>
                    </div>
                  </dl>
                </div>
              </div>
              <div class="con-piece" style="margin-bottom: 20px">
                <dl class="para-dl-piece">
                  <dt>证书号</dt>
                  <dd>
                    <input type="text" class="DiamondSearch-cert-input" v-model="database.search.CertNo" />
                  </dd>
                </dl>
                <dl class="para-dl-piece">
                  <dt>货号</dt>
                  <dd>
                    <input type="text" class="DiamondSearch-cert-input" v-model="database.search.d_Ref" />
                  </dd>
                </dl>
                <dl class="para-dl-range">
                  <dt class="caratQuickButton">克拉</dt>
                  <dd>
                    <div class="DiamondSearch-size-info clearfix">
                      <input type="text" class="DiamondSearch-size-input" v-model="database.search.start_weigth" />
                      <div class="DiamondSearch-size-separate">~</div>
                      <input type="text" class="DiamondSearch-size-input" v-model="database.search.end_weigth" />
                    </div>
                  </dd>
                </dl>
                <dl class="para-dl-range">
                  <dd>
                    <div class="DiamondSearch-size-select">
                      <select class="DiamondSearch-size-select-info" v-model="database.search.size" @change="changeSize">
                        <option v-for="(item, index) in select.size" :key="index" :value="item.val">{{item.name}}</option>
                      </select>
                    </div>
                  </dd>
                </dl>

                <div class="btnbox">
                  <a id="btnSearch" class="btn pink">
                    <!-- <i class="fa fa-circle-o" aria-hidden="true"></i> -->
                    <div class="DiamondSearch-foot-item active" @click="goSearch">搜索</div>
                  </a>
                  <a id="btnClear" class="btn gray">
                    <!-- <i class="fa fa-refresh" aria-hidden="true"></i> -->
                    <div class="DiamondSearch-foot-item" @click="resetSearch">重置</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="container-form">
          <div id="wrapper">
            <div id="scroller">
              <div id="tabs" name="diamonds">
                <div id="tblist">
                    <div class="pagelist"><div class="default"><span>共&nbsp;{{database.paging.totalrecord }}&nbsp;粒&nbsp;</span><span>单页&nbsp;20&nbsp;粒&nbsp;</span><span class="disabled">«上一页</span><span class="current">1</span><a href="#" @click="newpage(2);">2</a><a href="#" @click="newpage(3);">3</a><span>...</span><a href="#" @click="newpage(301);">301</a><a href="#" @click="newpage(2);">下一页»</a></div></div>
                  <table class="ltable">
                    <thead>
                      <tr>
                        <th>货号</th>
                        <th>形状</th>
                        <th>重量</th>
                        <th></th>
                        <th class="style1">颜色</th>
                        <th>净度</th>
                        <th>台深</th>
                        <th>奶色</th>
                        <th>折扣</th>
                        <th>证书</th>
                        <th>证书号</th>
                        <th>切工</th>
                        <th>拋光</th>
                        <th>对称</th>
                        <th>荧光</th>
                        <th>台宽</th>
                        <th>咖色</th>
                        <th></th>
                        <th>价格</th>
                        <th>加入购物车</th>
                        <th>立即下单</th>
                      </tr>
                    </thead>
                    <tbody class="tbody" :onAreMore="hasMore">
                        <tr id="row" class="statu_" v-for="(item, index) in dataList" :key="index" @click="showDetail(item)">
                        <td>{{item.d_ref || '-'}}</td>
                        <td>{{item.cnShape || '-'}}</td>
                        <td>{{item.d_size || '-'}}ct</td>
                        <td></td>
                        <td>{{item.color || '-'}}</td>
                        <td>{{item.clarity || '-'}}</td>
                        <td>{{item.d_depth || '-'}}mm</td>
                        <td>{{item.milkyText || '-'}}</td>
                        <td>{{0 - item.disc}}%</td>
                        <td>{{item.cert || '-'}}</td>
                        <td>{{item.certno || '-'}}</td>
                        <td>{{item.cut || '-'}}</td>
                        <td>{{item.polish || '-'}}</td>
                        <td>{{item.sym || '-'}}</td>
                        <td>{{item.flour || '-'}}</td>
                        <td>{{item.d_table || '-'}}mm</td>
                        <td>{{item.brownessText || '-'}}</td>
                        <td></td>
                        <td>{{item.price || '-'}}</td>
                        <td><a class="addshop" @click="onComplete('car')" title="加入购物车"></a></td>
                        <td><a class="addorder" @click="onComplete('order')" title="立即下单"></a></td></tr>
                      <tr v-if="!dataList.length && options.isOk">
                        <td colspan="25" rowspan="4" style="height: 200px" >
                          <span>请使用查询搜索调前查询你的意向宝石.</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
    <div class="modelBox" style="display:none;">
      <div class="model">
        <img src />
        <p class="timeer">
          <span>4</span>&nbsp;S
        </p>
        <i class="closed">x</i>
      </div>
    </div>
  </div>
</template>
<script>
import Core from '@/until/core'
import SideMenu from '@/public/SideMenu'
import _ from 'lodash'
export default {
  name: 'DiamondSearch',
  data () {
    return {
      options: {
        isOk: false,
        refreshDelay: 0,
        DiamondDetail: false,
        SideMenu: false
      },
      database: {
        search: {
          shape: [],
          start_weigth: '',
          end_weigth: '',
          size: '',
          color: [],
          clarity: [],
          three: '',
          cut: [],
          polish: [],
          sym: [],
          flour: [],
          Milky: '',
          Browness: '',
          CertNo: '',
          d_Ref: '',
          los: '',
          cert: []
        },
        paging: {
            uid: 9,
            order_name: 'price',
            order_type: 'ASC',
            pagesize: 20,
            pageint: 1,
            totalrecord: 0,
            totalpage: 0
        },
        list: [],
        selectItem: {}
      },
      select: {
        shape: [
          { val: 'ROUND', name: 'round', text: '圆形' },
          { val: 'PEAR', name: 'pear', text: '梨形' },
          { val: 'PRINCESS', name: 'princess', text: '公主方' },
          { val: 'HEART', name: 'heart', text: '心形' },
          { val: 'MARQUISE', name: 'marquise', text: '马眼形' },
          { val: 'OVAL', name: 'oval', text: '椭圆形' },
          { val: 'RADIANT', name: 'radiant', text: '雷蒂恩' },
          { val: 'EMERALD', name: 'emerald', text: '祖母绿' },
          { val: 'CUSHION', name: 'cushion', text: '垫形' },
          { val: 'TRIANGLE', name: 'triangle', text: '三角形' }
        ],
        size: [
          { val: '', name: '克拉段' },
          { val: '0.3-0.39', name: '0.3-0.39' },
          { val: '0.4-0.49', name: '0.4-0.49' },
          { val: '0.5-0.59', name: '0.5-0.59' },
          { val: '0.6-0.69', name: '0.6-0.69' },
          { val: '0.7-0.79', name: '0.7-0.79' },
          { val: '0.8-0.89', name: '0.8-0.89' },
          { val: '0.9-0.99', name: '0.9-0.99' },
          { val: '1.0-1.09', name: '1.0-1.09' },
          { val: '1.1-1.19', name: '1.1-1.19' },
          { val: '1.2-1.29', name: '1.2-1.29' },
          { val: '1.3-1.39', name: '1.3-1.39' },
          { val: '1.4-1.49', name: '1.4-1.49' },
          { val: '1.5-1.59', name: '1.5-1.59' },
          { val: '1.6-1.99', name: '1.6-1.99' },
          { val: '2.0-2.09', name: '2.0-2.09' },
          { val: '2.1.-2.99', name: '2.1.-2.99' },
          { val: '3.0.-3.09', name: '3.0.-3.09' },
          { val: '3.1.-3.99', name: '3.1.-3.99' },
          { val: '4.0.-4.09', name: '4.0.-4.09' },
          { val: '4.1.-4.99', name: '4.1.-4.99' },
          { val: '5.0.-20.0', name: '5.0.-20.0' }
        ],
        color: [
          { val: 'D', name: 'D' },
          { val: 'E', name: 'E' },
          { val: 'F', name: 'F' },
          { val: 'G', name: 'G' },
          { val: 'H', name: 'H' },
          { val: 'I', name: 'I' },
          { val: 'J', name: 'J' },
          { val: 'K', name: 'K' },
          { val: 'L', name: 'L' },
          { val: 'M', name: 'M' },
          { val: 'N', name: 'N' }
        ],
        clarity: [
          { val: 'FL', name: 'FL' },
          { val: 'IF', name: 'IF' },
          { val: 'VVS1', name: 'VVS1' },
          { val: 'VVS2', name: 'VVS2' },
          { val: 'VS1', name: 'VS1' },
          { val: 'VS2', name: 'VS2' },
          { val: 'SI1', name: 'SI1' },
          { val: 'SI2', name: 'SI2' },
          { val: 'SI3', name: 'SI3' },
          { val: 'I1', name: 'I1' }
        ],
        cut: [
          { val: 'Ideal', name: 'IDEAL' },
          { val: 'EX', name: 'EX' },
          { val: 'VG', name: 'VG' },
          { val: 'GD', name: 'GD' }
        ],
        flour: [
          { val: 'NONE', name: 'N' },
          { val: 'FAINT', name: 'F' },
          { val: 'MEDIUM', name: 'M' },
          { val: 'STRONG', name: 'S' },
          { val: 'VERY STRONG', name: 'VS' }
        ],
        cert: [
          { val: 'GIA', name: 'GIA' },
          { val: 'HRD', name: 'HRD' },
          { val: 'IGI', name: 'IGI' },
          { val: '国检', name: '国检' },
          { val: '统包货', name: '统包货' }
        ]
      }
    }
  },
  components: {
    SideMenu
  },
  watch: {},
  computed: {
    hasSearch () {
      return this.$store.state.hasSearch
    },
    diamSearch () {
      return this.$store.state.diamSearch
    },
    shapeList () {
      const arr = []
      for (let item of this.select.shape) {
        item.selected = false
        for (let value of this.database.search.shape) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    colorList () {
      const arr = []
      for (let item of this.select.color) {
        item.selected = false
        for (let value of this.database.search.color) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    clarityList () {
      const arr = []
      for (let item of this.select.clarity) {
        item.selected = false
        for (let value of this.database.search.clarity) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    cutList () {
      const arr = []
      const data = _.cloneDeep(this.select.cut)
      for (let item of data) {
        item.selected = false
        for (let value of this.database.search.cut) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    polishList () {
      const arr = []
      const data = _.cloneDeep(this.select.cut)
      for (let item of data) {
        item.selected = false
        for (let value of this.database.search.polish) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    symList () {
      const arr = []
      const data = _.cloneDeep(this.select.cut)
      for (let item of data) {
        item.selected = false
        for (let value of this.database.search.sym) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    flourList () {
      const arr = []
      for (let item of this.select.flour) {
        item.selected = false
        for (let value of this.database.search.flour) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    certList () {
      const arr = []
      for (let item of this.select.cert) {
        item.selected = false
        for (let value of this.database.search.cert) {
          if (item.val === value) {
            item.selected = true
          }
        }
        arr.push(item)
      }
      return arr
    },
    dataList () {
        const data = this.database.list || []
        const shape = ['ROUND', 'PRINCESS', 'PEAR', 'HEART', 'MARQUISE', 'OVAL', 'EMERALD', 'RADIANT', 'CUSHION', 'TRIANGLE']
        for (let value of data) {
            if (value.shape && shape.indexOf(value.shape) > -1) {
                value.fullPath = '/static/img/' + value.shape.toLowerCase() + '.png'
            }
            if (!value.fullPath) {
                value.fullPath = '/static/img/other.png'
            }
            value.price = parseInt(value.cny_price, 10) || 0
        }
        return data
    },
    uid () {
      return this.$route.params.Uid
    }
  },
  filters: {},
  methods: {
    goPage (name, bool) {
      const that = this
      if (bool) {
        return Core.goNext(name, that.$route.params)
      }
      Core.loginExist().then(res => {
        if (res) {
          return Core.goNext(name, that.$route.params)
        }
        // layer.alert('见到你真的很高兴', {icon: 6});
        Core.goNext('StaffLogin', that.$route.params)
      })
    },
    loginOut () {
      Core.onRemoveToken()
      Core.goNext('StaffLogin', this.$route.params, true)
    },
    onComplete (state) {
        if (state === 'car') {
            this.pushCar()
        } else if (state === 'order') {
            this.createOrder()
        }
    },
    hasMore () {
        return this.database.paging.totalpage > this.database.paging.pageint
    },
    pushCar (done) {
        const that = this
        const param = {}
        param.database = {}
        param.database.diamond_id = that.database.selectItem.id
        param.database.cart_product_number = 1
        that.$store.commit('onChangeAppLoaderShow', true)
        Core('Custommall/Cart/DiamondChange', param).then(result => {
            const res = result.data || {}
            if (res.error_code || !res.data) {
                that.$store.commit('onChangeAppLoaderShow', false)
                return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
            }
            if (done && typeof done === 'function') {
                return done(res)
            }
            that.$store.commit('onChangeAppLoaderShow', false)
            layer.msg('加入购物车成功！', {icon: 1})
        })
    },
    createOrder () {
        const that = this
        that.pushCar((car) => {
            const param = {}
            param.cart_id = []
            param.cart_id.push(car.data.cart_id)
            that.$store.commit('onChangeAppLoaderShow', true)
            Core('Custommall/Order/DiamondCartCreate', param).then(result => {
                that.$store.commit('onChangeAppLoaderShow', false)
                const res = result.data || {}
                if (res.error_code || !res.data) {
                    return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                }
                layer.msg('下单成功！', {icon: 1})
                Core.goNext('MyOrder', that.$route.params)
            })
        })
    },
    newpage (page) {
        const that = this
        console.log(this)
        console.log(page)
        if (!this.hasMore) {
            return layer.msg('已经是最后一页了！')
        } else {
            that.database.paging.pageint = page
            that.onGetList()
        }
        // if (that.database.paging.totalpage > that.database.paging.pageint) {
        //     that.database.paging.pageint += 1
        //     that.onGetList()
        // }
    },
    onSideMenu (state) {
      this.options.SideMenu = false
    },
    showDetail (item) {
                this.database.selectItem = item
            },
    onGetList () {
        const that = this
        const param = Object.assign({}, that.database.paging, that.diamSearch)
        that.$store.commit('onChangeAppLoaderShow', true)
        Core('Custommall/Diamond/Stafflists', param).then(result => {
            console.log(this.options)
            that.options.refreshDelay += 1
            that.$store.commit('onChangeAppLoaderShow', false)
            that.options.isOk = true
            const res = result.data || {}
            if (res.error_code || !res.data) {
                return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
            }
            that.database.paging.totalrecord = parseInt(res.data.totalrecord || 0, 10)
            that.database.paging.totalpage = parseInt(res.data.totalpage || 0, 10)
            that.database.list = _.concat([], res.data.list)
            // that.database.list = _.concat([], that.database.list, res.data.list)
        })
    },
    dataItem () {
        const data = this.item
        const shape = ['ROUND', 'PRINCESS', 'PEAR', 'HEART', 'MARQUISE', 'OVAL', 'EMERALD', 'RADIANT', 'CUSHION', 'TRIANGLE']
        if (data.shape && shape.indexOf(data.shape) > -1) {
            data.fullPath = '/static/img/' + data.shape.toLowerCase() + '.png'
        }
        if (!data.fullPath) {
            data.fullPath = '/static/img/other.png'
        }
        if (data.milky && parseInt(data.milky, 10) === 1) {
            data.milkyText = '有奶'
        } else {
            data.milkyText = '无奶'
        }
        if (data.browness && parseInt(data.browness, 10) === 1) {
            data.brownessText = '有咖'
        } else {
            data.brownessText = '无咖'
        }
        return data
    },
    selectItem (item, name) {
      if (this.database.search[name] && this.database.search[name].length) {
        for (let i = 0; i < this.database.search[name].length; i++) {
          if (this.database.search[name][i] === item.val) {
            this.database.search[name].splice(i, 1)
            return
          }
        }
      }
      this.database.search[name].push(item.val)
    },
    changeSize () {
      const size = this.database.search.size
      if (size) {
        this.database.search.start_weigth = size.split('-')[0] || ''
        this.database.search.end_weigth = size.split('-')[1] || ''
        return
      }
      this.database.search.start_weigth = ''
      this.database.search.end_weigth = ''
    },
    selectThree (value) {
      this.database.search.cut = []
      this.database.search.polish = []
      this.database.search.sym = []
      if (this.database.search.three === value) {
        this.database.search.three = ''
        return
      }
      this.database.search.three = value
      let arr = []
      if (value === '3IDEAL') {
        arr = ['Ideal']
      } else if (value === '3EX') {
        arr = ['Ideal', 'EX']
      } else if (value === '3VG') {
        arr = ['Ideal', 'EX', 'VG']
      } else if (value === '3GD') {
        arr = ['Ideal', 'EX', 'VG', 'GD']
      }
      this.database.search.cut = arr
      this.database.search.polish = arr
      this.database.search.sym = arr
    },
    resetSearch () {
      for (let i in this.database.search) {
        if (typeof this.database.search[i] === 'object') {
          this.database.search[i] = []
        } else {
          this.database.search[i] = ''
        }
      }
    },
    goSearch () {
      this.database.paging.uid = this.$route.params.Uid
      this.onGetList()
    //   this.$refs.tbody.html()
      console.log(this.database.search)
      console.log(this.$route.params)
      this.$store.commit('onChangeDiamSearch', this.database.search)
      this.$store.commit('onChangeHasSearch', true)
    //   Core.goNext('DiamondList', this.$route.params)
    },
    selectItemOne (value, name) {
      if (this.database.search[name] === value) {
        this.database.search[name] = ''
        return
      }
      this.database.search[name] = value
    },
    goBack () {
      Core.goBack()
    }
  },
  mounted () {
    if (this.hasSearch) {
        this.database.search = this.diamSearch
        this.$store.commit('onChangeHasSearch', false)
    }
  }
}
</script>
<style scoped>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../../static/css/yellow.css";
@import "../../static/css/font-awesome.css";
@import "../../static/css/default.css";
.Home-banner {
  width: 100%;
  height: 600px;
  background-color: #fff;
}
.btn-hk {
  color: #fff;
  padding: 8px 16px;
  line-height: 100px;
  background: #f268a3;
  border-radius: 2px;
  font-size: 13px;
}

.modelBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 999;
}

.model {
  position: absolute;
  width: 1000px;
  height: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: calc(50% - 350px);
  z-index: 9999;
  text-align: center;
  padding: 50px 0;
}

.closed {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 150px;
  top: 120px;
  text-align: center;
  line-height: 22px;
  background: #e0b12f;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.timeer {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100px;
  margin: auto;
  left: 0;
  right: 0;
  line-height: 40px;
  font-size: 14px;
  color: #ffeb3b;
  font-size: 18px;
  border-radius: 5px;
}
.nav {
  height: 90px;
}
.header-ce {
  width: 1000px;
}
.header-ce ul li {
  float: left;
  line-height: 90px;
  width: 100px;
  text-align: center;
}
.DiamondSearch-foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1rem;
  background-color: #fff;
  z-index: 11;
}
.DiamondSearch-foot-item {
  float: left;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 18px;
  margin-bottom: 100px;
}
.DiamondSearch-foot-item.active {
  color: #fff;
  float: right;
}

.DiamondSearch-item {
  width: 100%;
  background-color: #fff;
  margin-bottom: 20px;
}
.DiamondSearch-item-head {
  width: 10%;
  height: 146px;
  float: left;
  line-height: 146px;
  padding: 0 20px;
  font-size: 18px;
}
.DiamondSearch-item-container {
  width: 100%;
  padding: 10px 0;
}
.DiamondSearch-item-container.normal {
  padding: 10px;
}
.DiamondSearch-item-shape {
  float: left;
  width: 100px;
  padding: 10px;
}
.DiamondSearch-item-shape-box {
  width: 100%;
  height: 100px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  text-align: center;
}
.DiamondSearch-item-shape-icon {
  width: 100%;
  height: 60px;
}
.DiamondSearch-item-shape-text {
  width: 100%;
  height: 25px;
  line-height: 25px;
  font-size: 15px;
}
.DiamondSearch-item-shape-icon.round {
  background: url(../../static/img/yuan_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.pear {
  background: url(../../static/img/li_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.princess {
  background: url(../../static/img/gong_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.heart {
  background: url(../../static/img/xin_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.marquise {
  background: url(../../static/img/ma_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.oval {
  background: url(../../static/img/duo_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.radiant {
  background: url(../../static/img/lei_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.emerald {
  background: url(../../static/img/zu_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.cushion {
  background: url(../../static/img/dian_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-icon.triangle {
  background: url(../../static/img/san_shape.png) no-repeat 0 0;
  -webkit-background-size: 100% 80%;
  background-size: 100% 80%;
}
.DiamondSearch-item-shape-box.active {
  color: #ff410f;
  border-color: #ff410f;
}

.DiamondSearch-size {
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
}
.DiamondSearch-size-box {
  width: 100%;
  height: 88px;
  position: relative;
  padding-left: 1.4rem;
  padding-right: 1.8rem;
}
.DiamondSearch-size-name {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  line-height: 88px;
  font-size: 18px;
}
.DiamondSearch-size-info {
  width: 100%;
  height: 100%;
}
.DiamondSearch-size-input {
  float: left;
  width: 100px;
  height: 80px;
  border-radius: 40px;
  border: 1px solid #e0e0e0;
  text-align: center;
  font-size: 18px;
  padding: 0 10px;
}
.DiamondSearch-size-separate {
  float: left;
  width: 15px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  font-size: 18px;
}
.DiamondSearch-size-select {
  position: absolute;
  top: 0;
  width: 218px;
  left: 98px;
  border: 1px solid #c1c1c1;
}
.DiamondSearch-size-select-info {
  width: 100%;
  height: 7%;
  padding: 0 10px;
  font-size: 18px;
  border: none;
  outline: 0;
  background-color: #fff;
}
.DiamondSearch-item-normal {
  margin: 0 5px;
  float: left;
  width: 50px;
}
.DiamondSearch-item-normal-info {
  width: 99%;
  height: 3diamondsearch-item-normal0px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  background-color: #fff;
  outline: 0;
  white-space: nowrap;
}
.DiamondSearch-item-normal-info.active {
  border-color: #ff410f;
  background-color: #ff410f;
  color: #fff;
}

.DiamondSearch-cut {
  width: 1366px;
  background-color: #fff;
  margin: 20px auto;
  padding: 10px 0;
}
.DiamondSearch-cut-item {
  width: 100%;
  padding-left: 146px;
  position: relative;
}
.DiamondSearch-cut-name {
  position: absolute;
  left: 20px;
  top: 0;
  height: 100%;
  line-height: 88px;
  font-size: 18px;
}
.DiamondSearch-cut-list {
  width: 100%;
}
.DiamondSearch-cut-list-info {
  float: left;
  width: 80px;
  padding: 0 10px;
}
.DiamondSearch-cut-list-info.flour {
  width: 16%;
}

.DiamondSearch-cert {
  width: 100%;
  padding-left: 1.46rem;
  position: relative;
  margin: 10px 0;
}
.DiamondSearch-cert-info {
  width: 100%;
  height: 88px;
  padding: 0 20px;
}
.DiamondSearch-cert-input {
  width: 100%;
  height: 100%;
  border-radius: 40px;
  border: 1px solid #e0e0e0;
  font-size: 18px;
  padding: 0 10px;
  outline: 0;
}
.para-div-lt {
  max-width: 470px;
}
.con-piece {
  bottom: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/DiamondSearch.vue